import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "main-table" }
const _hoisted_2 = { class: "filter-form" }
const _hoisted_3 = { class: "button-opera" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode("新增申请")
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = /*#__PURE__*/_createTextVNode("编辑")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_input_search = _resolveComponent("a-input-search")
  const _component_a_form_item = _resolveComponent("a-form-item")
  const _component_a_range_picker = _resolveComponent("a-range-picker")
  const _component_a_input = _resolveComponent("a-input")
  const _component_a_select_option = _resolveComponent("a-select-option")
  const _component_a_select = _resolveComponent("a-select")
  const _component_a_form = _resolveComponent("a-form")
  const _component_a_button = _resolveComponent("a-button")
  const _component_a_table = _resolveComponent("a-table")
  const _component_add = _resolveComponent("add")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode(_component_a_form, {
        model: _ctx.filter,
        layout: "inline",
        labelAlign: "right"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_form_item, {
            style: {"width":"200px"},
            label: "",
            name: "corpName"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_input_search, {
                value: _ctx.filter.corpName,
                "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => (_ctx.filter.corpName = $event)),
                placeholder: "请输入企业名称",
                "allow-clear": true,
                onSearch: _ctx.refresh
              }, null, 8, ["value", "onSearch"])
            ]),
            _: 1
          }),
          _createVNode(_component_a_form_item, null, {
            default: _withCtx(() => [
              _createVNode(_component_a_range_picker, {
                value: _ctx.filter.timeRange,
                "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => (_ctx.filter.timeRange = $event)),
                onChange: _ctx.refresh
              }, null, 8, ["value", "onChange"])
            ]),
            _: 1
          }),
          _createVNode(_component_a_form_item, null, {
            default: _withCtx(() => [
              _createVNode(_component_a_input, {
                modelValue: _ctx.filter.mobile,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.filter.mobile = $event)),
                style: {"width":"200px"},
                placeholder: "手机号：请输入申请手机号",
                onPressEnter: _ctx.refresh
              }, null, 8, ["modelValue", "onPressEnter"])
            ]),
            _: 1
          }),
          _createVNode(_component_a_form_item, null, {
            default: _withCtx(() => [
              _createVNode(_component_a_select, {
                value: _ctx.filter.status,
                "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => (_ctx.filter.status = $event)),
                onChange: _ctx.refresh,
                placeholder: "状态：请选择",
                allowClear: true
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.statusOptions, (item) => {
                    return (_openBlock(), _createBlock(_component_a_select_option, {
                      key: item.id,
                      value: item.id
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(item.name), 1)
                      ]),
                      _: 2
                    }, 1032, ["value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["value", "onChange"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["model"]),
      _createVNode("div", _hoisted_3, [
        _createVNode(_component_a_button, {
          type: "primary",
          onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.addAction()))
        }, {
          default: _withCtx(() => [
            _hoisted_4
          ]),
          _: 1
        })
      ])
    ]),
    _createVNode(_component_a_table, {
      scroll: _ctx.scroll,
      "data-source": _ctx.data,
      columns: _ctx.columns,
      loading: _ctx.loading,
      pagination: _ctx.pagination,
      ref: "tableElRef",
      onChange: _ctx.handleTableChange,
      "row-key": (record) => record.id
    }, {
      createTime: _withCtx(({ record }) => [
        _createVNode("div", null, _toDisplayString(_ctx.formatDate(record.createTime, 'YYYY-MM-DD HH:mm')), 1)
      ]),
      attachments: _withCtx(({ record }) => [
        _createVNode("div", null, [
          (record.attachments && record.attachments != '[]')
            ? (_openBlock(), _createBlock("div", _hoisted_5, [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(JSON.parse(
                                record.attachments
                            ), (item, index) => {
                  return (_openBlock(), _createBlock("a", {
                    target: "_blank",
                    href: item,
                    key: index
                  }, _toDisplayString(item), 9, ["href"]))
                }), 128))
              ]))
            : (_openBlock(), _createBlock("div", _hoisted_6, "-"))
        ])
      ]),
      updateTime: _withCtx(({ record }) => [
        _createVNode("div", null, _toDisplayString(_ctx.formatDate(record.updateTime, 'YYYY-MM-DD HH:mm')), 1)
      ]),
      action: _withCtx(({ record }) => [
        _createVNode(_component_a_button, {
          type: "link",
          onClick: ($event: any) => (_ctx.modAction(record))
        }, {
          default: _withCtx(() => [
            _hoisted_7
          ]),
          _: 2
        }, 1032, ["onClick"])
      ]),
      _: 1
    }, 8, ["scroll", "data-source", "columns", "loading", "pagination", "onChange", "row-key"]),
    (_ctx.store.state.msgauditApply.addState)
      ? (_openBlock(), _createBlock(_component_add, {
          key: 0,
          onSuccess: _ctx.fetchList
        }, null, 8, ["onSuccess"]))
      : _createCommentVNode("", true)
  ]))
}